module.exports = __webpack_public_path__ + "img/light-2.003147a9.svg";